import * as React from 'react';
import TextHelper from '../../../../../../../../core/helpers/TextHelper';
import { Block, Text } from '../../../../../../../components';
import constants from '../../../../../constants';

const ProgressDataUser = (props: any) => {
  const {
    period,
    career,
    weightedAverage,
    newProgram,
    newCampus,
    newModality,
    hasDebts,
    selectedProcedureId
  } = props;
  return (
    <Block>
      <Text>Resumen:</Text>
      <ul style={{ listStyle: 'unset', marginLeft: 16, paddingLeft: 8 }}>
        {period && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Periodo: <strong>{period}.</strong>
            </Text>
          </li>
        )}
        {career && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Carrera: <strong>{TextHelper.capitalize(career)}.</strong>
            </Text>
          </li>
        )}
        {weightedAverage && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Promedio ponderado acumulado:{' '}
              <strong>{weightedAverage.toString().replace('.', ',')}.</strong>
            </Text>
          </li>
        )}
        {newModality && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Modalidad: <strong>{newModality}.</strong>
            </Text>
          </li>
        )}
        {newCampus && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Campus: <strong>{newCampus}.</strong>
            </Text>
          </li>
        )}
        {newProgram && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Carrera: <strong>{TextHelper.capitalize(newProgram)}.</strong>
            </Text>
          </li>
        )}
        {selectedProcedureId ===
          constants.categories.certificates.type1Ids[6] && (
          <li>
            <Text lineHeight="20px" fontSize="14px">
              Detalle:{' '}
              <strong>
                {hasDebts ? 'Mantiene deudas' : 'No mantiene deudas'}.
              </strong>
            </Text>
          </li>
        )}
      </ul>
    </Block>
    // <>
    //   {procedureId === constants.categories.certificates.type1Ids[0] ? (
    //     <Block>
    //       <Text>Resumen</Text>
    //       <Text lineHeight="20px" fontSize="14px">
    //         Periodo solicitado:<strong>{period}</strong>
    //       </Text>
    //     </Block>
    //   ) : (
    //     <Block>
    //       <Text>Resumen</Text>
    //       <ul style={{ listStyle: 'unset', marginLeft: 16 }}>
    //         {period && (
    //           <li>
    //             <Text lineHeight="20px" fontSize="14px">
    //               Ciclo: <strong>{period}</strong>
    //             </Text>
    //           </li>
    //         )}
    //         {career && (
    //           <li>
    //             <Text lineHeight="20px" fontSize="14px">
    //               Carrera: <strong>{career}</strong>
    //             </Text>
    //           </li>
    //         )}
    //       </ul>
    //     </Block>
    //   )}
    // </>
  );
};

export default ProgressDataUser;
